import React from "react"
import clsx from "clsx"
import Link from "~components/link/link"
import * as styles from "./syntax-guide.module.css"

export default ({ tokenType, returnType, name, args }) => (
  <div
    className={clsx(styles.syntaxGuide, {
      [styles.functionToken]: tokenType === "function",
      [styles.statementToken]: tokenType === "statement",
    })}
  >
    <code>
      {(returnType === "VOID" && <span className={styles.keywordType}>VOID</span>) ||
        (returnType && (
          <Link className={styles.keywordType} to={`/reference/vcl/types/${returnType.toLowerCase()}`}>
            {returnType}
          </Link>
        ))}
      <span className={styles.keywordName}>{name}</span>
      {(tokenType === "function" || args) && (
        <span className={styles.args}>
          {args &&
            args.map(({ name, type, arity }) => (
              <span
                key={name}
                className={clsx(styles.argToken, {
                  [styles.variadic]: arity === "variadic",
                  [styles.optional]: arity === "optional",
                })}
              >
                <Link className={styles.keywordType} to={`/reference/vcl/types/${type.toLowerCase()}`}>
                  {type}
                </Link>
                <span className={styles.keywordArg}>{name}</span>
              </span>
            ))}
        </span>
      )}
      {tokenType === "statement" && <>;</>}
    </code>
  </div>
)
